import React, { Fragment, useEffect, useState } from 'react';
import { Helmet } from "react-helmet";
import AuthDataProvider from "./utils/storages/authDataProvider";
import ProfileDataProvider from "./utils/storages/profileDataProvider";
import ToastDataProvider from "./utils/storages/toastDataProvider";
import Splash from './pages/splash/Splash';
import PWA from './pages/PWA/PWA';
import Router from "./Router";
import { Loading } from 'podro-design-system';
import Dialog from './commonComponents/dialog/Dialog';
import { Row } from 'reactstrap';

function App() {

    // useEffect(() => {
    //     if (process.env.REACT_APP_ENV === "development" ) {
    //         (function () {
    //             const noScript = document.createElement("noscript"),
    //                 script = document.createElement("iframe");
    //             script.src = "https://www.googletagmanager.com/ns.html?id=GTM-KWQSR3R";
    //             script.width = "0";
    //             script.height = "0";
    //             script.style = "display:none;visibility:hidden";

    //             noScript.appendChild(script);

    //             document.body.appendChild(noScript);
    //         }())
    //     }
    // }, []);
    // if (process.env.REACT_APP_ENV === "development") {
    //     console.log("Service worker test");
    // }

    const [hasUpdateDialogOpen, setHasUpdateDialogOpen] = useState(false);

    useEffect(() => {
        if (process.env.REACT_APP_ENV !== "demo") {
            let updateTimeout;
            document.addEventListener("update-new-content", function (event) {
                if (event?.detail?.hasUpdate) {
                    setHasUpdateDialogOpen(true);
                    updateTimeout = setTimeout(() => {
                        hotReload();
                    }, 4000);
                }
            });
            return () => clearTimeout(updateTimeout);
        }

    }, []);

    const hotReload = () => {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
            registrations.forEach((registration) => {
                registration.unregister();
            });
        });
        caches.keys().then((keyList) => {
            return Promise.all(
              keyList.map((key) => {
                return caches.delete(key);
              })
            );
        });
        window.location.reload();
    }
    
    return (
        <Fragment>
            {process.env.REACT_APP_ENV === "development" && (
                <Helmet>
                    {/* <script async>
                        {`
                            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                            })(window,document,'script','dataLayer','GTM-KWQSR3R');
                        `}
                    </script> */}
                    <script async>
                        {`
                            (function(g,u,i,d,e,s){
                                g[e]=g[e]||[];
                                var f=u.getElementsByTagName(i)[0];
                                var k=u.createElement(i);
                                k.async=true;
                                k.src='https://static.userguiding.com/media/user-guiding-'+s+'-embedded.js';
                                f.parentNode.insertBefore(k,f);
                                if(g[d])return;
                                var ug=g[d]={q:[]};
                                ug.c=function(n){
                                    return function(){
                                        ug.q.push([n,arguments])};
                                    };
                                    var m=['previewGuide','finishPreview','track','identify','triggerNps','hideChecklist','launchChecklist'];
                                    for(var j=0;j<m.length;j+=1){ug[m[j]]=ug.c(m[j]);}
                                })(window,document,'script','userGuiding','userGuidingLayer','411559956ID'); 
                        `}
                    </script>
                </Helmet>   
            )}
            {process.env.REACT_APP_ENV === "production" && (
                <Helmet>

                    <script async src="https://www.googletagmanager.com/gtag/js?id=UA-155214118-1"/>
                    <script async>
                        {`
                            window.dataLayer = window.dataLayer || [];
                            function gtag(){dataLayer.push(arguments);}
                            gtag('js', new Date());
                            gtag('config', 'UA-155214118-1');
                        `}
                    </script>
                    <script async>
                        {`
                            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                            })(window,document,'script','dataLayer','GTM-KWQSR3R');
                        `}
                    </script>
                    <script async type="text/javascript">
                        {`
                            (function(c,l,a,r,i,t,y){
                            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
                            })(window, document, "clarity", "script", "4cdosd44d4");
                        `}
                    </script>
                    <script async>
                        {`
                            !(function (t, e, n) {
                                (t.yektanetAnalyticsObject = n),
                                (t[n] =
                                    t[n] ||
                                    function () {
                                    t[n].q.push(arguments);
                                    }),
                                (t[n].q = t[n].q || []);
                                var a = new Date(),
                                r =
                                    a.getFullYear().toString() +
                                    "0" +
                                    a.getMonth() +
                                    "0" +
                                    a.getDate() +
                                    "0" +
                                    a.getHours(),
                                c = e.getElementsByTagName("script")[0],
                                s = e.createElement("script");
                                s.id = "ua-script-EfnGeFKp";
                                s.dataset.analyticsobject = n;
                                s.async = 1;
                                s.type = "text/javascript";
                                (s.src =
                                "https://cdn.yektanet.com/rg_woebegone/scripts_v3/EfnGeFKp/rg.complete.js?v=" +
                                r),
                                c.parentNode.insertBefore(s, c);
                            })(window, document, "yektanet");
                        `}
                    </script>                    
                </Helmet>
            )} 
            <ToastDataProvider>
                <AuthDataProvider>
                    <ProfileDataProvider>
                        <PWA/>
                        <Splash>
                            <Router/>
                        </Splash>
                    </ProfileDataProvider>
                </AuthDataProvider>
            </ToastDataProvider>

            <Dialog
                disableSwipe
                disableClose
                size={4}
                openBottomSheet={hasUpdateDialogOpen}
                changeBottomSheet={() => setHasUpdateDialogOpen}
                title={<div className=" black-icon">بروزرسانی</div>}
            >
                <Row noGutters>
                    <div className='font-12 mb-3'>در حال بروزرسانی، لطفا چند ثانیه منتظر بمانید.</div>
                    <div className='d-flex w-100 justify-content-center'>
                        <Loading/>
                    </div>
                </Row>
            </Dialog>
        </Fragment>
    );
}

export default App;
